import {gsap} from "gsap";
import {ScrollTrigger} from 'gsap/ScrollTrigger'

const animations = {
    menu: () => import('./../animations/compare-yacht-menu'),
    revealTextByLine: () => import('./../animations/reveal-text-by-line')
  },
  toRevealTexts = document.querySelectorAll('.text-reveal'),
  splitAndRevealText = () => {
    if (toRevealTexts.length > 0) {
      animations.revealTextByLine().then(module => {
        for (const text of toRevealTexts) {
          module.revealTextByLine(text)
        }
      })
    }
  }

export const compareYacht = () => {
  var YACHT1 = "";
  var YACHT2 = "";

  var YACHT1_SELECT = true;
  var YACHT2_SELECT = false;

  if (jQuery(".already-setted").length > 0) {
    YACHT1 = jQuery(".already-setted").attr("data-id");
  }

  splitAndRevealText()

  var added = false;
  const menuTriggers = document.querySelectorAll('.compare__menu-triggers,.close-select-series')
  var addmodel = document.querySelectorAll('.add-model')
  const selectSeries = document.querySelectorAll('.select-series-compare')
  const closeYachtSelect = document.querySelectorAll('.close-select-yacht')
  var closeBtn = document.querySelectorAll('.close-select-yacht')
  var element_line = document.querySelectorAll('.line')
  var close_select_series = document.querySelectorAll('.close-select-series')
  var subproducts = document.querySelectorAll('.sub-products')
  var productselection = document.querySelectorAll('.product-selection')
  var backmobilesss = document.querySelectorAll('.back-mobile-sss')
  const desktopYachtSeries = document.querySelectorAll('.select-series-compare')
  let isOpen_series = false
  let isOpen = false

  if (desktopYachtSeries.length > 0) {
    for (const series of desktopYachtSeries) {

      series.addEventListener('mouseenter', () => {
        for (const el of desktopYachtSeries) {
          el.style.opacity = el === series ? 1 : .3
        }
      })

      series.addEventListener('mouseleave', () => {
        for (const el of desktopYachtSeries) {
          el.style.opacity = 1
        }
      })
    }
  }


  $(document).on("click", ".add-model", function () {
    YACHT2_SELECT = true;
    YACHT1_SELECT = false;
    openMenu();
  });

  $(document).on("click", ".change-model1", function () {
    YACHT2_SELECT = false;
    YACHT1_SELECT = true;
    openMenu();
  });
  $(document).on("click", ".change-model2", function () {
    YACHT2_SELECT = true;
    YACHT1_SELECT = false;
    openMenu();
  });

  if (backmobilesss.length > 0) {
    for (const trigger_bm of backmobilesss) {
      trigger_bm.addEventListener('click', () => {

        isOpen_series = false;
        var element = document.querySelectorAll('.select-sub-series')
        var seriescontainer = document.querySelectorAll('.series-container')
        var selectmodellabel1 = document.querySelectorAll('.select-model-label1')

        jQuery(".select-series").removeClass("glass--light");

        gsap.to(selectmodellabel1, {
          opacity: 1,
          pointerEvents: 'all',
          x: 0,
          duration: .4,
          delay: 0.2
        })
        gsap.to(seriescontainer, {
          opacity: 1,
          pointerEvents: 'all',
          x: 0,
          duration: .4,
          delay: 0.2
        })
        gsap.to(element, {
          opacity: 0,
          x: 20,
          pointerEvents: 'none',
          duration: .4,
          delay: 0
        })
        gsap.to(element, {
          clipPath: 'inset(0% 100% 0% 0%)',
          duration: 0,
          delay: 0.5
        })

      })
    }
  }
  if (selectSeries.length > 0) {
    for (const trigger_s of selectSeries) {
      trigger_s.addEventListener('click', event => {

        //TRACKING GTM :_D
        if (YACHT1) {
          document.dispatchEvent(new CustomEvent('selectSerie', {detail: {yacht1: false, yacht2: true}}));
        } else {
          document.dispatchEvent(new CustomEvent('selectSerie', {detail: {yacht1: true, yacht2: false}}));
        }

        isOpen_series = true;
        var element = document.querySelectorAll('.select-sub-series')
        var subproduct_ok = document.querySelectorAll('.sub-products[data-id="' + event.target.getAttribute("data-id") + '"]')
        var seriescontainer = document.querySelectorAll('.series-container')
        var selectmodellabel1 = document.querySelectorAll('.select-model-label1')

        if (jQuery(window).width() < 1024) {


          jQuery(".select-series").addClass("glass--light");

          gsap.to(element, {
            clipPath: 'inset(0% 0% 0% 0%)',
            duration: 0,
            delay: 0
          })
          jQuery(".padder-scroller").scrollTop(0);
          gsap.to(subproducts, {
            opacity: 0,
            position: 'absolute',
            duration: 0,
            display: 'none',
            delay: 0,
            pointerEvents: 'none'
          });
          gsap.to(subproduct_ok, {
            opacity: 1,
            position: 'relative',
            display: 'block',
            duration: 0,
            delay: 0,
            pointerEvents: 'all'
          })

          gsap.to(selectmodellabel1, {
            opacity: 0,
            pointerEvents: 'none',
            x: -20,
            duration: .4,
            delay: 0
          })
          gsap.to(seriescontainer, {
            opacity: 0,
            pointerEvents: 'none',
            x: -20,
            duration: .4,
            delay: 0
          })
          gsap.to(element, {
            opacity: 1,
            x: -20,
            pointerEvents: 'all',
            duration: .4,
            delay: .2
          })

        } else {
          gsap.to(closeBtn, {
            opacity: isOpen_series ? 1 : 0,
            rotate: isOpen_series ? 0 : '-90deg',
            delay: isOpen_series ? 0.8 : 0
          })

          gsap.to(subproducts, {
            opacity: 0,
            position: 'absolute',
            display: 'none',
            duration: .3,
            delay: 0,
            pointerEvents: 'none'
          })
          setTimeout(function () {
            jQuery(".padder-scroller").scrollTop(0);
          }, 500);
          gsap.to(subproduct_ok, {
            opacity: 1,
            position: 'relative',
            display: 'block',
            duration: .7,
            delay: 1,
            pointerEvents: 'all'
          })

          gsap.to(close_select_series, {
            opacity: !isOpen_series ? 1 : 0
          })

          gsap.to(element, {
            clipPath: 'inset(0% 0% 0% 0%)',
            duration: .7,
            delay: 0
          })
          gsap.to(element_line, {
            height: '100%',
            duration: .7,
            delay: 0
          })
        }


      })
    }
  }

  if (productselection.length > 0) {
    for (const trigger_ps of productselection) {
      trigger_ps.addEventListener('click', () => {
        isOpen_series = false;
        isOpen = false;
        var element = document.querySelectorAll('.select-sub-series')

        //TRACKING GTM :_D
        if (YACHT1) {
          document.dispatchEvent(new CustomEvent('selectModel', {detail: {yacht1: false, yacht2: true}}));
        } else {
          document.dispatchEvent(new CustomEvent('selectModel', {detail: {yacht1: true, yacht2: false}}));
        }

        if (jQuery(window).width() < 1024) {

          gsap.to(closeBtn, {
            opacity: isOpen_series ? 1 : 0,
            rotate: isOpen_series ? 0 : '-90deg',
            delay: isOpen_series ? 0.8 : 0
          })
          gsap.to(subproducts, {
            opacity: 0,
            position: 'absolute',
            duration: .3,
            delay: 0.7
          })
          gsap.to(close_select_series, {
            opacity: !isOpen_series ? 1 : 0
          })
          gsap.to(document.querySelectorAll('.select-series'), {
            clipPath: 'inset(0% 100% 0% 0%)',
            duration: .7,
            delay: 0
          })
          gsap.to(element, {
            clipPath: 'inset(0% 100% 0% 0%)',
            duration: .7,
            delay: 0
          })


          var seriescontainer = document.querySelectorAll('.series-container')
          var selectmodellabel1 = document.querySelectorAll('.select-model-label1')
          var element = document.querySelectorAll('.series-container')
          gsap.to(subproducts, {
            opacity: 0,
            position: 'absolute',
            duration: 0,
            delay: 0.7,
            pointerEvents: 'none'
          })

          gsap.to(selectmodellabel1, {
            opacity: 1,
            pointerEvents: 'none',
            x: 0,
            duration: 0,
            delay: 0.7
          })
          gsap.to(seriescontainer, {
            opacity: 0,
            pointerEvents: 'none',
            x: 0,
            duration: 0,
            delay: 0.7
          })
          gsap.to(element, {
            opacity: 1,
            x: 0,
            pointerEvents: 'all',
            duration: 0,
            delay: 0.7
          })
          animations.menu().then(module => module.compareYachtMenu(isOpen, document.querySelectorAll(".select-series-compare > span")))
          gsap.to(document.querySelectorAll('.first-step'), {
            opacity: 0,
            duration: .7,
            delay: .7
          })
        } else {
          gsap.to(closeBtn, {
            opacity: isOpen_series ? 1 : 0,
            rotate: isOpen_series ? 0 : '-90deg',
            delay: isOpen_series ? 0.8 : 0
          })
          gsap.to(subproducts, {
            opacity: 0,
            position: 'absolute',
            duration: .3,
            delay: 0
          })
          gsap.to(element, {
            clipPath: 'inset(0% 100% 0% 0%)',
            duration: .7,
            delay: 0
          })
          gsap.to(element_line, {
            height: '0%',
            duration: .7,
            delay: 0
          })
          gsap.to(document.querySelectorAll('.select-series'), {
            clipPath: 'inset(0% 100% 0% 0%)',
            duration: .7,
            delay: .7
          })

          gsap.to(document.querySelectorAll('.first-step'), {
            opacity: 0,
            duration: .7,
            delay: .7
          })
        }


        var YACHT_ID = event.target.getAttribute("data-id");
        if (!YACHT1_SELECT && !YACHT2_SELECT) {
          YACHT1 = YACHT_ID;
        } else if (YACHT1_SELECT) {
          YACHT1 = YACHT_ID;
        } else if (YACHT2_SELECT) {
          YACHT2 = YACHT_ID;
          gsap.to(document.querySelectorAll('.add-model-mobile'), {
            opacity: 0,
            duration: .7,
            y: 46,
            delay: 0
          });
        }

        YACHT2_SELECT = false;
        YACHT1_SELECT = false;
        var LANGUAGE = $("html").attr("lang");
        if (LANGUAGE == "it-IT")
          LANGUAGE = "it"
        else
          LANGUAGE = "en"

        jQuery.ajax({
          url: ajaxurl,
          method: 'POST',
          data: {
            action: 'functions',
            function: 'get_yacht',
            data: {YACHT1, YACHT2, LANGUAGE}
          },
          success: function (response) {
            setTimeout(function () {

              if (YACHT1 && YACHT2) {
                //TRACKING GTM :_D
                document.dispatchEvent(new CustomEvent('compareYachts', {
                  detail: {
                    yacht1: $(".product-selection[data-id='" + YACHT1 + "'] .sr-only").text(),
                    yacht2: $(".product-selection[data-id='" + YACHT2 + "'] .sr-only").text()
                  }
                }));
              }

              $(".first-step").remove();
              $("#compare-container").html(response);
              setTimeout(function () {
                gsap.to(document.querySelectorAll('#compare-container'), {
                  opacity: 1,
                  duration: .7
                });
                jQuery(".select-series").removeClass("glass--light");
                if (!added) {
                  gsap.to(document.querySelectorAll('.add-model-mobile'), {
                    opacity: 1,
                    duration: .7,
                    y: 0,
                    delay: .7
                  });
                }
                added = true;

                $(document).trigger("resize");
                ScrollTrigger.refresh();
              }, 300);
            }, 600);
          },
          error: function (XMLHttpRequest, textStatus, errorThrown) {
            consoel.log("Status: " + textStatus, "Error: " + errorThrown);
          },
        });


      })
    }
  }
  if (closeYachtSelect.length > 0) {
    for (const trigger_c of closeYachtSelect) {
      trigger_c.addEventListener('click', () => {
        isOpen_series = false;
        var element = document.querySelectorAll('.select-sub-series')
        if (jQuery(window).width() < 1024) {
          isOpen = !isOpen
          gsap.to(closeBtn, {
            opacity: isOpen_series ? 1 : 0,
            rotate: isOpen_series ? 0 : '-90deg',
            delay: isOpen_series ? 0.8 : 0
          })
          gsap.to(subproducts, {
            opacity: 0,
            position: 'absolute',
            duration: .3,
            delay: 0.7
          })
          gsap.to(close_select_series, {
            opacity: !isOpen_series ? 1 : 0
          })
          gsap.to(document.querySelectorAll('.select-series'), {
            clipPath: 'inset(0% 100% 0% 0%)',
            duration: .7,
            delay: 0
          })
          gsap.to(element, {
            clipPath: 'inset(0% 100% 0% 0%)',
            duration: .7,
            delay: 0
          })
          jQuery(".select-series").removeClass("glass--light");

          var seriescontainer = document.querySelectorAll('.series-container')
          var selectmodellabel1 = document.querySelectorAll('.select-model-label1')
          var element = document.querySelectorAll('.series-container')
          gsap.to(subproducts, {
            opacity: 0,
            position: 'absolute',
            duration: 0,
            delay: 0.7,
            pointerEvents: 'none'
          })

          gsap.to(selectmodellabel1, {
            opacity: 1,
            pointerEvents: 'none',
            x: 0,
            duration: 0,
            delay: 0.7
          })
          gsap.to(seriescontainer, {
            opacity: 0,
            pointerEvents: 'none',
            x: 0,
            duration: 0,
            delay: 0.7
          })
          gsap.to(element, {
            opacity: 1,
            x: 0,
            pointerEvents: 'all',
            duration: 0,
            delay: 0.7
          })
          animations.menu().then(module => module.compareYachtMenu(isOpen, document.querySelectorAll(".select-series-compare > span")))

        } else {
          gsap.to(closeBtn, {
            opacity: isOpen_series ? 1 : 0,
            rotate: isOpen_series ? 0 : '-90deg',
            delay: isOpen_series ? 0.8 : 0
          })
          gsap.to(subproducts, {
            opacity: 0,
            position: 'absolute',
            duration: .3,
            delay: 0
          })
          gsap.to(close_select_series, {
            opacity: !isOpen_series ? 1 : 0
          })

          gsap.to(element, {
            clipPath: 'inset(0% 100% 0% 0%)',
            duration: .7,
            delay: 0
          })
          gsap.to(element_line, {
            height: '0%',
            duration: .7,
            delay: 0
          })
        }

      })
    }
  }


  if (menuTriggers.length > 0) {
    for (const trigger of menuTriggers) {
      trigger.addEventListener('click', () => {
        openMenu();
      })
    }
  }

  function openMenu() {
    isOpen = !isOpen


    var element = document.querySelectorAll('.select-series')
    var closeBtn1 = document.querySelectorAll('.close-select-series')
    gsap.to(closeBtn1, {
      opacity: isOpen ? 1 : 0,
      rotate: isOpen ? 0 : '-90deg',
      delay: isOpen ? 0.8 : 0
    })
    gsap.to(element, {
      clipPath: isOpen ? 'inset(0% 0% 0% 0%)' : 'inset(0% 100% 0% 0%)',
      duration: .7,
      delay: 0
    })

    if ($(window).width() < 1024) {
      var element1 = document.querySelectorAll('.select-sub-series')
      gsap.to(element1, {
        clipPath: 'inset(0% 100% 0% 0%)',
        opacity: 0,
        pointerEvents: 'none',
        x: 0,
        duration: 0,
        delay: 0
      })
    }
    animations.menu().then(module => module.compareYachtMenu(isOpen, document.querySelectorAll(".select-series-compare > span")))
  }


  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  if (urlParams.has('yacht-id')) {
    gsap.to(document.querySelectorAll('.add-model-mobile'), {opacity: 1, duration: .7, y: 0, delay: .7});
    added = true;
  }
}
